import { Test } from "../_Test/Test.js"
const test = new Test()
test.sayHello()

import { Lead } from "../mod_lead/mod_lead.js"
const lead = new Lead()
window.lead = lead

import { quizMuseum, pswpMuseum } from "../mod_journal/mod_journal.js"
document.addEventListener("DOMContentLoaded", quizMuseum);
//document.addEventListener("DOMContentLoaded", pswpMuseum);
/* document.addEventListener("DOMContentLoaded", function() {
	quizMuseum();
	pswpMuseum();
}); */

sbjs.init();

/* Mobile Nav */
$(".mob-btn").on("click", function() {
	$(this)
		.closest("#nav")
		.toggleClass("active")
	return false
})
/* Btn Open Block */
$(".spoiler_toggler").on("click", function() {
	$(this)
		.closest("#accordion-section div.p")
		.toggleClass("open-block")
	return false
})
/* ScrollBtn */
$("#menu").on("click", "a", function(event) {
	event.preventDefault()
	var id = $(this).attr("href"),
		top = $(id).offset().top
	$("body,html").animate({ scrollTop: top }, 1500)
})
/* Slick Slider-1 */
$(".slider").slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
			},
		},
	],
});
/* Slick Slider-2 */
$(".carousel").slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	dots: true,
	responsive: [
		{
			breakpoint: 480,
			settings: {
				dots: false,
			},
		},
	],
});
/* Slick Slider-3 */
$(".slider-goods").slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	dots: true
});
/* Slick Slider-4 */
$(".visualization").slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	dots: true
});
/* Slick Slider-5 */
$(".solutions-awards__list").slick({
	slidesToShow: 4,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1
			}
		}
	]
});
$(".solutions-examples__preview-list").each(function(){
	let pos = $(this).closest('li').index() + 1;
	/* Slick Slider-6 */
	$(this).slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		fade: true,
		asNavFor: '.solutions-examples__item:nth-of-type(' + pos + ') .solutions-examples__slider-list'
	});
	/* Slick Slider-7 */
	$('.solutions-examples__item:nth-of-type(' + pos + ') .solutions-examples__slider-list').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		adaptiveHeight: true,
		asNavFor: '.solutions-examples__item:nth-of-type(' + pos + ') .solutions-examples__preview-list'
	});
});
/* Slick Slider-8 */
$(".solutions-reviews__list").slick({
	slidesToShow: 4,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1
			}
		}
	]
});
/* Tabs */
$(".tabset ul.tab-control li a:not(.link)").on("click", function() {
	var thisHold = $(this).closest(".tabset")
	var _ind = $(this)
		.closest("li")
		.index()
	thisHold
		.children(".tab-body")
		.children(".tab")
		.removeClass("active")
	thisHold
		.children(".tab-body")
		.children("div.tab:eq(" + _ind + ")")
		.addClass("active")
	$(this)
		.closest("ul")
		.find(".active")
		.removeClass("active")
	$(this)
		.parent()
		.addClass("active")
	return false
})
$(".tabset-vertical ul.tab-control li a").on("click", function() {
	var thisHold = $(this).closest(".tabset-vertical")
	var _ind = $(this)
		.closest("li")
		.index()
	thisHold
		.children(".tab-body")
		.children(".tab")
		.removeClass("active")
	thisHold
		.children(".tab-body")
		.children("div.tab:eq(" + _ind + ")")
		.addClass("active")
	$(this)
		.closest("ul")
		.find(".active")
		.removeClass("active")
	$(this)
		.parent()
		.addClass("active")
	return false
})
// Tabs 2
$(".tabs")
	.children(".tabs__content")
	.not(":first")
	.hide();
$(".tabs__nav-btn").click(function() {
	$(".tabs__nav-btn")
		.removeClass("active")
		.eq($(this).index())
		.addClass("active");
	$(".tabs__content")
		.hide()
		.eq($(this).index())
		.fadeIn();
})
.eq(0)
.addClass("active");

/* Btn Show More */
$(".show-more").on("click", function() {
	$(".portfolio-list.expanded").toggleClass("open")
	return false
})
/*$(".show-list").on("click", function() {
	$(this).toggleClass("open")
	$(this).siblings('.projection-screens-goods-list.expanded').slideToggle()
	return false
})*/
$('.expanded-opener').on('click', function() {
  $(this).closest('.select-box').toggleClass('open');
  $(this).closest('.option-box').toggleClass('open');
  $(this).siblings('.expanded').slideToggle();
  return false;
})
$('button.open-filter').on('click', function() {
  $(this).closest('.aside-filter').toggleClass('active');
  $('.filter-form').slideToggle();
  return false;
})
/* CustomSelect */
$('.custom-select select').select2();
/* Slider-Range */

$('.slider-range').each(function(){
	let el = $(this);
	let num = $(this).attr('id').replace(/slider-range-/, '');

	$(this).slider({
	  min: parseInt($('#filter_' + num + '_first').val()),
	  max: parseInt($('#filter_' + num + '_last').val()),
	  values: [parseInt($('#filter_' + num + '_min').val()), parseInt($('#filter_' + num + '_max').val())],
	  range: true,
	  stop: function(event, ui) {
		$('#filter_' + num + '_min').val(el.slider("values",0));
		$('#filter_' + num + '_max').val(el.slider("values",1));
	  },
	  slide: function(event, ui){
		$('#filter_' + num + '_min').val(el.slider("values",0));
		$('#filter_' + num + '_max').val(el.slider("values",1));
	  }
	});

	$('#filter_' + num + '_min').change(function(){
	  let value1 = $('#filter_' + num + '_min').val();
	  let value2 = $('#filter_' + num + '_max').val();
		if(parseInt(value1) > parseInt(value2)){
		value1 = value2;
		$('#filter_' + num + '_min').val(value1);
	  }
	  el.slider("values", 0, value1);
	});

	$('#filter_' + num + '_max').change(function(){
	  let value1 = $('#filter_' + num + '_min').val();
	  let value2 = $('#filter_' + num + '_max').val();
	  if(parseInt(value1) > parseInt(value2)){
		value2 = value1;
		$('#filter_' + num + '_max').val(value2);
	  }
	  el.slider("values", 1, value2);
	});

	// фильтрация ввода в поля
	el.find('input').keypress(function(event){
	  var key, keyChar;
	  if(!event) var event = window.event;
	  if (event.keyCode) key = event.keyCode;
	  else if(event.which) key = event.which;
	  if(key==null || key==0 || key==8 || key==13 || key==9 || key==46 || key==37 || key==39 ) return true;
	  keyChar=String.fromCharCode(key);
	  if(!/\d/.test(keyChar)) return false;
	});

});


function resetForm(form)
{
	form.find('input[type="checkbox"]').prop('checked', false);
	form.find('input[type="text"]').val('');
}

$('#sort_select').change(function(){
	if ($(this).val() == 1)
		$('#sort_input').val('price_asc')
	else if ($(this).val() == 2)
		$('#sort_input').val('price_desc')
	else if ($(this).val() == 3)
		$('#sort_input').val('name')
	else
		$('#sort_input').val('')

	$('.filter-form form')[0].submit();
});

$('.select-list-result .delete').click(function(){
	var prop = $(this).attr('data-prop');
	var value = $(this).attr('data-value');

	$('.filter-form input[name^=filter_' + prop + '][value="' + value + '"]').prop('checked', false);
	$('.filter-form form')[0].submit();
});

$('.item-result.btn-reset').click(function(){
   resetForm($('.filter-form form'));
	$('.filter-form form')[0].submit();
});
$('#reset_button').click(function(){
   resetForm($('.filter-form form'));
	$('.filter-form form')[0].submit();
});

$(document.forms['filter-form']).submit(function(){
	let form = $(this);
	if (form.find('input[type=checkbox]:checked').length == 1)
	{
		let el = form.find('input[type=checkbox]:checked');
		if (el.attr('data-url') && el.attr('data-url') != '-')
		{
			let url = form.attr('action') + el.attr('data-url') + '/';
			document.location.href = url;
			return false;
		}
	}
	return true;
});


/* Adaptive Table */
if (
	/(iPhone|iPad|iPod)/gi.test(navigator.userAgent) &&
	window.location.pathname.indexOf("/full") > -1
) {
	var p = document.createElement("p")
	p.innerHTML =
		'<a target="_blank" href="https://s.codepen.io/dbushell/debug/wGaamR"><b>Click here to view this demo properly on iOS devices (remove the top frame)</b></a>'
	document.body.insertBefore(p, document.body.querySelector("h1"))
}
/* Player Form */
$(".phone").mask("+7 (000) 000 00 00", { placeholder: "+7 ( _____ ) _____  ___  ___" , clearIfNotMatch: true})

// $("form[name != 'search_form']").not("[name = 'filter-form']").each(function() {
// 	var form = $(this),
// 		input = form.find("input")
// 	form.find(".required").blur(function() {
// 		var val = $(this).val()
// 		if (/^[a-zA-Zа-яА-ЯіІєЄїЇ\s-]{1,40}$/gi.test(val)) {
// 			$(this).removeClass("error rubberBand animated")
// 		} else {
// 			$(this).addClass("error rubberBand animated")
// 			$(this).val("")
// 		}
// 	})
// 	form.on("keyup keydown", ".required.error", function() {
// 		var val = $(this).val()
// 		if (/^[a-zA-Z0-9а-яА-ЯіІєЄїЇ\s-\(\)\+]{1,40}$/gi.test(val)) {
// 			$(this).removeClass("error rubberBand animated")
// 		} else {
// 			$(this).addClass("error rubberBand animated")
// 		}
// 	})
// 	form.find(".phone").blur(function() {
// 		var val = $(this).val()
// 		if (/^[0-9\s-\(\)\+]{18}$/gi.test(val)) {
// 			$(this).removeClass("error rubberBand animated")
// 		} else {
// 			$(this).addClass("error rubberBand animated")
// 			$(this).val("")
// 		}
// 	})
// 	form.on("keyup keydown", ".phone.error", function() {
// 		var val = $(this).val()
// 		if (/^[0-9\s-\(\)\+]{18}$/gi.test(val)) {
// 			$(this).removeClass("error rubberBand animated")
// 		} else {
// 			$(this).addClass("error rubberBand animated")
// 		}
// 	})
// 	form.find(".email").blur(function() {
// 		var val = $(this).val()
// 		if (
// 			/^[-\._a-z0-9]+@(?:[a-z0-9][-a-z0-9]+\.)+[a-z]{2,6}$/gi.test(val) &&
// 			val.length <= 30
// 		) {
// 			$(this).removeClass("error rubberBand animated")
// 		} else {
// 			$(this).addClass("error rubberBand animated")
// 			$(this).val("")
// 		}
// 	})
// 	form.on("keyup keydown", ".email.error", function() {
// 		var val = $(this).val()
// 		if (
// 			/^[-\._a-z0-9]+@(?:[a-z0-9][-a-z0-9]+\.)+[a-z]{2,6}$/gi.test(val) &&
// 			val.length <= 30
// 		) {
// 			$(this).removeClass("error rubberBand animated")
// 		} else {
// 			$(this).addClass("error rubberBand animated")
// 		}
// 	})
// 	form.submit(function(e) {
// 		input.trigger("blur")
// 		if ($(form).find(".error").length) {
// 			/*alert('error');*/
// 			return false
// 		} else {
// 			$(".popup-holder").css("display", "none")
// 			$("#popup2.popup-holder").css("display", "block")
// 			$(".close-popup").on("click", function() {
// 				$(".popup-holder").css("display", "none")
// 				$("body").removeClass("no-scroll")
// 				return false
// 			})
// 			// alert('Заявка принята!')
// 			// $.post("feedback.php", $(this).serialize());
// 			/*values = $(this).serialize()
// 			console.log()
// 			$.ajax({
// 				url: "feedback.php",
// 				type: "post",
// 				data: values,
// 				success: function() {
// 					// успех
// 					form.find("input[type=text]").each(function() {
// 						$(this).val("")
// 					})
// 					$(".info-box").hide()
// 					$(".container").css({
// 						display: "table-cell",
// 					})
// 				},
// 				error: function() {
// 					// ошибка
// 				},
// 			})*/
// 			return false
// 		}
// 	})
// })

$('a[href^="#"]').not('.popup-link').click(function () {
	 let elementClick = $(this).attr("href").replace(/#/, '');
	 if (elementClick && $('a[name='+elementClick+']').length)
	 {
		 let destination = $('a[name='+elementClick+']').offset().top;
		 $('html, body').animate( { scrollTop: destination }, 1100 );
		 return false;
	 }
 });

$('.num-list__toggle').click(function(){
	$(this).siblings('.num-list__popup').fadeToggle()
});

$('.solutions-price__item-request').click(function(){
	$('.popup--solutions-price').addClass('active');
	$('body').addClass('no-scroll');
});

$('.solutions-preview__btn').click(function(){
	$('.popup--video').addClass('active');
	$('.popup--video iframe').attr('src', $(this).attr('data-video'));
	// $('.popup--video iframe').attr('src', 'https://www.youtube.com/embed/' + $(this).attr('data-youtube'));
	$('body').addClass('no-scroll');
});

$('.prompt__toggler').click(function(){
	$('.prompt__popup').fadeToggle();
});

$(document).click(function(e) {
	var callbackPopup = $(".prompt")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(".prompt__popup").fadeOut();
	}
})

$('.solutions-examples__preview-item img').click(function(){
	$(this).closest('.solutions-examples__preview-list').siblings('.popup--slider').addClass('active');
	$('body').addClass('no-scroll');
});

$('.popup__close').click(function(){
	$(this).parents('.popup').removeClass('active');
	$('body').removeClass('no-scroll');
});

$('.new-form__main .new-form__item--with-options .new-form__input').focus(function(){
	$(this).parent().find('.new-form__options').slideDown();
});
$('.new-form__main .new-form__item--with-options .new-form__input').blur(function(){
	$(this).parent().find('.new-form__options').slideUp();
});
$('.new-form__main .new-form__item--with-options .new-form__options-input').change(function(){
	$(this).closest('.new-form__item--with-options').find('.new-form__input--options').val($(this).val()).trigger('keyup');

});

$('.solutions-screens__item').click(function(){
	$(this).children('.solutions-screens__item-text').toggleClass('active');
});

$(document).click(function(e) {
	var callbackPopup = $(".popup__container, .solutions-price__item-request, .solutions-preview__btn, .solutions-examples__preview-item img")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(".popup").removeClass('active');
		$('body').removeClass('no-scroll');
	}
})

$('.equipment__item-toggle').click(function(){
	$(this).parent().siblings('.equipment__item-hidden').slideToggle()
});

// Проверка на тач-устройство
if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
	$('.visualization__point-button').addClass('touch');
	$('.education-complect__image-nav-button').addClass('touch');
} else {
	$('.visualization__point-button').addClass('no-touch');
	$('.education-complect__image-nav-button').addClass('no-touch');
}

$('.visualization__point-button.touch').click(function(){
	let pos = $(this).attr('data-pos');

	$('.visualization__point-button').not($(this)).siblings('.visualization__point-popup').removeClass('active');
	$('.visualization__image').not('.visualization__image--' + pos).removeClass('active');

	$(this).siblings('.visualization__point-popup').toggleClass('active')
	$('.visualization__image--' + pos).toggleClass('active');
});


$('.visualization__point-button.no-touch').hover(function(){
	let pos = $(this).attr('data-pos');
	$('.visualization__image--' + pos).toggleClass('active');
});

$('.education-complect__image-nav-button.no-touch').hover(function(){
	let pos = $(this).attr('data-pos');
	let block = $(this).closest('.education-complect__image');

	block.find('.education-complect__image-nav-button').not($(this)).siblings('.education-complect__image-nav-button').removeClass('active');
	block.find('.education-complect__image-item').not('.education-complect__image-item--' + pos).removeClass('active');

	$(this).addClass('active');
	block.find('.education-complect__image-item--' + pos).addClass('active');
});

$('.education-complect__image-nav-button.touch').click(function(){
	let pos = $(this).attr('data-pos');
	let block = $(this).closest('.education-complect__image');

	block.find('.education-complect__image-nav-button').not($(this)).siblings('.education-complect__image-nav-button').removeClass('active');
	block.find('.education-complect__image-item').not('.education-complect__image-item--' + pos).removeClass('active');

	$(this).addClass('active');
	block.find('.education-complect__image-item--' + pos).addClass('active');
});


if ($('a[rel=lightbox_vsc]').length && $('.pswp').length)
{
	let i = 0;
	$('a[rel=lightbox_vsc]').each(function()
	{
		let _i = i;
		$(this).click(function()
		{
			item_content_photos(_i);
			return false;
		});
		i++;
	});
}

//уменьшить шрифт на мобильных, если длинное слово в заголовке не помещается
const mediaQuery = window.matchMedia('(max-width: 360px)');
const changeFontSize = (el) => {
	let size = $(el).css('font-size');
	let sizeInt = parseInt(size.match(/\d+/));
	$(el).css('font-size', (sizeInt - 2.5) + 'px');
}
function onTextChange(elem) {
	//- получить текст заголовка
	let text = $(elem).text();
	//- создать массив из отдельных слов
	let textArr = text.split(' ');
	//- искать длинное слово, если есть - уменьшить шрифт
	textArr.forEach(word => {
		if (word.length > 17) {
			changeFontSize(elem)
		} else return;
	})
}
if (mediaQuery.matches) onTextChange('.promo .holder .description h1');

//плавный скролл до якорей
$(document).ready(function() {
	let margin = -15; // отступ
	$('.museum-page a[href^="#"], .repair-page a[href^="#"]').on('click', function() {
		$("html, body").animate({
			scrollTop: $($(this).attr("href")).offset().top+margin+ "px"
		}, {
			duration: 1600, // скорость
			easing: "swing"
		});
		return false;
	});
});

$(document).ready(function() {
	//найти iframe на странице
	//добавить класс для адаптации iframe по ширине/высоте на мобильных устройствах
	$("#content .wrap-text iframe").each(function() {
		$(this).addClass('iframe-container ')
	});

	//найти img на странице
	//добавить инлайн-стили для адаптации img по ширине/высоте на мобильных устройствах
	//(в админке жестко задаются width/height)
	$("#content .wrap-text img").each(function() {
		let w = $(this)[0].style.width;

		//если есть width и задана в px
		if (w && /px$/.test(w)) {
			$(this)[0].style.maxWidth = w;
			$(this)[0].style.height = 'auto';
			$(this)[0].style.width = '100%';
		}
	});

	$(".museum-page .equipment__item-image a").on('click', function() {
		let id = $(this).attr('data-id') - 1;
		pswpMuseum(id)
		return false;
	});
});
